"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class InvalidClassIdsParameter extends client_library_1.ExtendableError {
    constructor() {
        super('Invalid classIds parameter, must be an array of strings');
    }
}
exports.default = InvalidClassIdsParameter;
//# sourceMappingURL=InvalidClassIdsParameter.js.map